import { PaginationType } from "../../../../../../../../common/interfaces/flow/action/WebRequestAction";
import { autoIncrementTemplate, responseBasedTemplate, customTemplate } from "./paginationTemplates";

export const newDefaultPagination = (variableName, type) => {
  let pag = createPagination();
  switch (type) {
    case PaginationType.AUTO_INCREMENT:
      pag = createPagination(type, variableName ? variableName : "page", autoIncrementTemplate(variableName ? variableName : "page", 1, 1));
      break;
    case PaginationType.RESPONSE_BASED:
      pag = createPagination(type, variableName ? variableName : "cursor", responseBasedTemplate("", "$.nextCursor"));
      break;
    case PaginationType.CUSTOM:
      pag = createPagination(type, variableName ? variableName : "custom", customTemplate(variableName ? variableName : "custom"));
      break;
    default:
      break;
  }
  return pag;
};
export const setPaginationBreakJsonPath = (pagination, breakJsonPath) => {
  if (pagination) {
    pagination.breakJsonPath = breakJsonPath;
    return pagination;
  } else {
    let pag = createPagination();
    pag.breakJsonPath = breakJsonPath;
    return pag;
  }
};
export const setPaginationStatus = (pagination, status) => {
  if (pagination) {
    pagination.enabled = status;
    return pagination;
  } else {
    let pag = createPagination();
    pag.enabled = status;
    return pag;
  }
};
export const setPaginationVariableName = (pagination, name) => {
  if (pagination) {
    pagination.variable.name = name;
    return pagination;
  } else {
    let pag = createPagination();
    pag.variable.name = name;
    return pag;
  }
};
export const setPaginationVariableScript = (pagination, script) => {
  if (pagination) {
    pagination.variable.script = script;
    return pagination;
  } else {
    let pag = createPagination();
    pag.variable.script = script;
    return pag;
  }
};

export const createPagination = (type, variableName, script) => {
  return {
    enabled: false,
    breakJsonPath: "$",
    type: type ? type : "",
    variable: {
      name: variableName ? variableName : "",
      script: script ? script : "",
    },
  };
};
